import { useSelector } from "react-redux";

import { TotalsLine } from "components/formFields/Totals/TotalsLine";

import { i18n } from "services/i18nService";
import { formatMoneyValueFixedDigits } from "services/utility/formatting";
import { isNonZeroDecimalOrMoney } from "services/utility/misc";

import { usePrivileges } from "hooks/usePrivileges";

import { USER_PRIVILEGE } from "appConstants";

export function LineItemTotals(props) {
  const { totals } = props;

  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const viewCosts = hasPrivilegesOrIsAdmin(USER_PRIVILEGE.viewCosts);

  const globalEnabled = useSelector(
    (state) => state.userCompanySettings.settings.globalEnabled
  );
  const taxEnabled = useSelector(
    (state) => state.userCompanySettings.settings.taxEnabled
  );

  const currencyMinimumFractionDigits = useSelector(
    (state) =>
      state.userCompanySettings.localization.currencyMinimumFractionDigits
  );

  const showTax = taxEnabled || isNonZeroDecimalOrMoney(totals.tax);

  const localizedTax =
    globalEnabled && showTax
      ? formatMoneyValueFixedDigits(totals.tax, currencyMinimumFractionDigits)
      : null;

  const localizedAmount = formatMoneyValueFixedDigits(
    totals.amount,
    currencyMinimumFractionDigits
  );

  const localizedTotal = formatMoneyValueFixedDigits(
    totals.total,
    currencyMinimumFractionDigits
  );

  if (!viewCosts) {
    return null;
  }

  return (
    <div style={{ alignSelf: "baseline" }}>
      {globalEnabled && showTax ? (
        <>
          <TotalsLine label={i18n("global.Subtotal")} value={localizedAmount} />
          {showTax && (
            <TotalsLine label={i18n("global.Tax")} value={localizedTax} />
          )}
          <TotalsLine
            dataTesting="total"
            label={i18n("global.Total")}
            value={localizedTotal}
          />
        </>
      ) : (
        <TotalsLine
          dataTesting="total"
          label={i18n("global.Total")}
          value={localizedAmount}
        />
      )}
    </div>
  );
}
